// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"76cf6416","806":"1ba6698a"}[chunkId] + ".chunk.js";
};